module.exports = __webpack_public_path__ + "img/layout-tablet-mg.86d53ad3.png";